export default from './Share'


// WEBPACK FOOTER //
// ./src/components/Share/index.js